/**
 * Frontend Constants
 *
 * Re-exported from @loader/shared-types for centralized definitions.
 */

// Re-export for backwards compatibility - prefer using CALCULATED_TABLE_ALIAS directly
export { CALCULATED_TABLE_ALIAS as CALCULATED_COLUMNS_TABLE_ALIAS } from '@loader/shared-types';

// Also export the canonical name for new code
export { CALCULATED_TABLE_ALIAS } from '@loader/shared-types';

/**
 * Max age for a version/upload to be considered in-progress before treating as stale.
 * After this threshold, the frontend stops polling and treats the operation as timed out.
 * The backend cron job handles longer-term cleanup (60 min) in production.
 */
export const MAX_PROCESSING_STALENESS_MS = 5 * 60 * 1000; // 5 minutes
